//
//
//
//
//
//
//
//
//
//
//
//

import {wgs84ToBd09} from './geo_conversion'
export default {
  name: 'baidu-map',
  
  props: {
    // 地图高度（像素）
    mapHeight: {
      type: Number,
      default: 500
    },
    // 默认中心点经度
    centerLng: {
      type: Number,
      default: 116.404
    },
    // 默认中心点纬度
    centerLat: {
      type: Number,
      default: 39.915
    },
    // 默认缩放级别
    zoomLevel: {
      type: Number,
      default: 15
    },
    // 是否启用倾斜和旋转
    enableTiltAndRotate: {
      type: Boolean,
      default: false
    },
    // 是否显示3D建筑
    show3DBuildings: {
      type: Boolean,
      default: true
    },
    mapData: {
        type: Array,
        default(){
        return [];
        },
    },
    isUnitHotel: {
        type: Boolean,
        default: false,
    },

  },
  
  data() {
    return {
      loading: true,           // 加载状态
      loadError: false,        // 加载错误
      mapInstance: null,       // 地图实例
      BMapGL: null,            // 地图API
      retryCount: 0,           // 重试次数
      maxRetries: 3,           // 最大重试次数
      mapLoaded: false,        // 地图是否已加载
      marker: null,            // 标记点
      defaultPoint: null,       // 默认中心点
      ak:'12U0g3N0svovq18DIFLLHy8u'
    };
  },
  
  mounted() {
    this.initMap();
  },
  
  beforeDestroy() {
    // 组件销毁前清理地图
    this.destroyMap();
  },
  
  methods: {
    // 初始化地图
    async initMap() {
      this.loading = true;
      this.loadError = false;
      
      try {
        // 加载百度地图API
        await this.loadBMapAPI();
        
        // 确保地图容器存在
        if (!this.$refs.mapContainer) {
          throw new Error('地图容器不存在');
        }
        const len = this.mapData.length;
        const centerData = this.mapData[Math.floor(len / 2)];
        const bd09 = wgs84ToBd09(Number(centerData.longitude),Number(centerData.latitude));
        
        // 创建地图实例
        this.createMap(bd09);
        if(len > 0){
            if(this.isUnitHotel){
                this.renderMarkerIcon(bd09)
            }else{
                this.renderPriceMarker()
            }
        }
        
        // 触发加载完成事件
        // this.$emit('map-loaded', this.mapInstance);
        
      } catch (error) {
        console.error('地图初始化失败:', error);
        this.handleLoadError(error);
      }
    },
    
    // 加载百度地图API
    loadBMapAPI() {
      return new Promise((resolve, reject) => {
        // 如果已加载，直接返回
        if (window.BMapGL) {
          this.BMapGL = window.BMapGL;
          resolve();
          return;
        }
        
        // 定义全局回调函数
        window.onBMapGLScriptLoad = () => {
          if (window.BMapGL) {
            this.BMapGL = window.BMapGL;
            resolve();
          } else {
            reject(new Error('BMapGL未定义'));
          }
          // 清理回调
          delete window.onBMapGLScriptLoad;
        };
        
        // 创建script标签
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://api.map.baidu.com/api?v=3.0&ak=${this.ak}&type=webgl&callback=onBMapGLScriptLoad`;
        
        script.onerror = () => {
          reject(new Error('加载百度地图API失败'));
          delete window.onBMapGLScriptLoad;
        };
        
        // 设置超时
        const timeoutId = setTimeout(() => {
          reject(new Error('加载百度地图API超时'));
          delete window.onBMapGLScriptLoad;
          document.head.removeChild(script);
        }, 10000);
        
        script.onload = () => {
          clearTimeout(timeoutId);
        };
        
        // 添加到文档
        document.head.appendChild(script);
      });
    },
    
    // 创建地图实例
    createMap(bd09) {
      const BMapGL = this.BMapGL;
      const point = new BMapGL.Point(bd09[0],bd09[1])
      // 创建默认点
    //   this.defaultPoint = new BMapGL.Point(this.centerLng, this.centerLat);
      
      // 创建地图实例
      this.mapInstance = new BMapGL.Map(this.$refs.mapContainer, {
        minZoom: 3,        // 最小缩放级别
        maxZoom: 19,       // 最大缩放级别
        enableAutoResize: true,  // 自动调整大小
      });
      
      // 设置中心点和缩放级别
      this.mapInstance.centerAndZoom(point, this.zoomLevel);
      
      // 启用滚轮缩放
      this.mapInstance.enableScrollWheelZoom(true);
      this.mapInstance.enableDoubleClickZoom(true);
      
    },
    renderMarkerIcon(bd09){
        const BMapGL = this.BMapGL;
        const point = new BMapGL.Point(bd09[0],bd09[1])
        
        var marker1 = new BMapGL.Marker(point);
        this.mapInstance.addOverlay(marker1)
    },
    renderPriceMarker(){
        const BMapGL = this.BMapGL;
        for(let [index,item] of this.mapData.entries()){
            const bd09 = wgs84ToBd09(Number(item.longitude),Number(item.latitude));
            let center =  new BMapGL.Point(bd09[0],bd09[1])
            var customOverlay = new this.BMapGL.CustomOverlay(this.renderDom, {
                point: center,
                opacity: 0.5,
                offsetY: -10,
                properties: {
                    item:item,index:index
                }
            });
            this.mapInstance.addOverlay(customOverlay);
        }
    },
    renderDom(e){
        let _this = this;
        let item = e.item
        let index = e.index
        console.log(e)
        var div = document.createElement('div');
        div.style.height = '56px';
        div.style.width = '110px';
        div.style.display = 'flex';
        div.style.justifyContent = 'center';
        div.style.alignItems = 'center';

        div.style.fontSize = '12px';
        var div1 = document.createElement('div');
        let price = parseInt(item.min_price.price) || 0
        if(price>0){
            div1.classList.add('zIndex')
        }
        div1.classList.add('chat-bubble-white')
        
        
        var title = document.createElement('div');
        title.classList.add('chat-name')
        let abbr1 = item.hotel_name.toString().length>10?item.hotel_name.substr(0,10)+'...':item.hotel_name
        title.appendChild(document.createTextNode(abbr1));
        var priceDiv = document.createElement('div');
        priceDiv.classList.add('price-text')
        if(price>0){
            priceDiv.appendChild(document.createTextNode(`${item.min_price.currency_code} ${price}`));
        }
        
        
        div1.appendChild(title);
        div1.appendChild(priceDiv);
        div.appendChild(div1);
        div.onclick = function (){
            //清除上一个选中样式
            let zIndexDom =  document.querySelector('.zIndex')
            let chatDom1 =  document.querySelector('.chat-bubble')
            if(zIndexDom){
                zIndexDom.classList.remove('zIndex')
            }
            if(chatDom1){
                chatDom1.classList.remove('chat-bubble')
                chatDom1.classList.add('chat-bubble-white')
            }
            div1.style.zIndex = ''
            div1.classList.add('zIndex');
            div1.classList.add('chat-bubble')
            div1.classList.remove('chat-bubble-white')
            _this.$emit('on-data-index',index)

        }
        return div
    },
    // 添加默认标记点
    addDefaultMarker() {
      const BMapGL = this.BMapGL;
      
      // 创建标记点
      this.marker = new BMapGL.Marker(this.defaultPoint);
      
      // 添加标记点
      this.mapInstance.addOverlay(this.marker);
      
      // 添加信息窗口
      const infoWindow = new BMapGL.InfoWindow('北京市', {
        width: 200,
        height: 40,
        title: '位置信息'
      });
      
      // 标记点点击事件
      this.marker.addEventListener('click', () => {
        this.mapInstance.openInfoWindow(infoWindow, this.defaultPoint);
        this.$emit('marker-click', {
          lng: this.defaultPoint.lng,
          lat: this.defaultPoint.lat
        });
      });
    },
    
    // 添加地图控件
    addMapControls() {
      const BMapGL = this.BMapGL;
      
      // 添加比例尺控件
      const scaleCtrl = new BMapGL.ScaleControl();
      this.mapInstance.addControl(scaleCtrl);
      
      // 添加缩放控件
      const zoomCtrl = new BMapGL.ZoomControl();
      this.mapInstance.addControl(zoomCtrl);
      
      // 添加版权控件
      const copyrightCtrl = new BMapGL.CopyrightControl();
      this.mapInstance.addControl(copyrightCtrl);
      
      // 添加定位控件（需要HTTPS）
      if (window.location.protocol === 'https:') {
        const locationCtrl = new BMapGL.LocationControl({
          anchor: window.BMAP_ANCHOR_BOTTOM_RIGHT,
          offset: new BMapGL.Size(10, 30)
        });
        this.mapInstance.addControl(locationCtrl);
      }
    },
    
    // 设置地图样式（可选）
    setMapStyle() {
      // 这里可以自定义地图样式
      // 例如：https://lbsyun.baidu.com/index.php?title=jspopularGL/guide/mapstyle
    },
    
    // 处理加载错误
    handleLoadError(error) {
      this.loading = false;
      this.loadError = true;
      
      // 如果重试次数未达到上限，可以自动重试
      if (this.retryCount < this.maxRetries) {
        this.retryCount++;
        console.log(`地图加载失败，第${this.retryCount}次重试...`);
        
        // 延迟重试
        setTimeout(() => {
          this.retryLoad();
        }, 2000 * this.retryCount);
      }
      
      this.$emit('map-load-error', error);
    },
    
    // 重试加载
    retryLoad() {
      this.retryCount = 0;
      this.initMap();
    },
    
    // 放大
    zoomIn() {
      if (this.mapInstance) {
        this.mapInstance.zoomIn();
      }
    },
    
    // 缩小
    zoomOut() {
      if (this.mapInstance) {
        this.mapInstance.zoomOut();
      }
    },
    
    // 重置视图
    resetView() {
      if (this.mapInstance && this.defaultPoint) {
        this.mapInstance.centerAndZoom(this.defaultPoint, this.zoomLevel);
        if (this.enableTiltAndRotate) {
          this.mapInstance.setTilt(45);
        }
      }
    },
    
    // 设置地图中心点
    setCenter(lng, lat) {
      if (this.mapInstance) {
        const point = new this.BMapGL.Point(lng, lat);
        this.mapInstance.panTo(point);
        this.$emit('center-changed', { lng, lat });
      }
    },
    
    // 添加标记点
    addMarker(lng, lat, title = '') {
      if (!this.mapInstance || !this.BMapGL) return null;
      
      const point = new this.BMapGL.Point(lng, lat);
      const marker = new this.BMapGL.Marker(point);
      
      // 如果有标题，添加点击事件
      if (title) {
        const infoWindow = new this.BMapGL.InfoWindow(title, {
          width: 200,
          height: 40
        });
        
        marker.addEventListener('click', () => {
          this.mapInstance.openInfoWindow(infoWindow, point);
        });
      }
      
      this.mapInstance.addOverlay(marker);
      return marker;
    },
    
    // 清除所有标记点
    clearMarkers() {
      if (this.mapInstance) {
        this.mapInstance.clearOverlays();
      }
    },
    
    // 销毁地图
    destroyMap() {
      if (this.mapInstance) {
        this.mapInstance.destroy();
        this.mapInstance = null;
      }
      
      // 清理全局回调
      delete window.onBMapGLScriptLoad;
    }
  },
  
  watch: {
    // 监听地图高度变化
    mapHeight(newHeight) {
      if (this.mapInstance) {
        // 触发地图resize
        setTimeout(() => {
          if (this.mapInstance) {
            this.mapInstance.checkResize();
          }
        }, 100);
      }
    },
    
    // 监听中心点变化
    centerLng(newVal, oldVal) {
      if (newVal !== oldVal && this.mapInstance) {
        this.setCenter(newVal, this.centerLat);
      }
    },
    
    centerLat(newVal, oldVal) {
      if (newVal !== oldVal && this.mapInstance) {
        this.setCenter(this.centerLng, newVal);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/BaiduMap/BaiduMap.vue